import React from 'react';
import { Checkbox } from '@mui/material';

import palette from '@/theme/palette.ts';

export const TableCheckBox = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange?: (selectedRowId?: number) => void;
}) => {
  return (
    <Checkbox
      sx={{
        minWidth: 40,
        height: 40,
        color: palette.icon.default,
        '&.Mui-checked': {
          color: palette.icon.checked,
        },
      }}
      checked={checked}
      onChange={() => onChange && onChange()}
    />
  );
};
